import { urlRootPath } from 'helpers/urlPath'
import { NEWS_URL_PART } from 'pages/Event/_containers/Event/_constants/EVENT_URLS'

export const SPORT_URL_PART = 'sports',
  SPORT_URL = urlRootPath(SPORT_URL_PART),
  DEFAULT_SPORT_PAGE_URL_PART = NEWS_URL_PART
